import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { formValueSelector, reduxForm } from "redux-form";

import Loader from "../Common/Loader/Loader";
import PrefferedProviderDetails from "./PrefferedProviderDetails/PrefferedProviderDetails";
import noServiceProviderIcon from '../../../public/dashboard/noServiceProviderIcon.svg';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";

import messages from "../../locale/messages";

import { closeHeaderModal, openHeaderModal } from "../../actions/siteadmin/modalActions";
import { getServiceProvider } from "../../actions/booking/getServiceProvider";
import { createBookingAction } from "../../actions/booking/createBookingAction";

import bt from '../../components/commonStyle.css';

function PreferredProviderForm({ formData }) {

    const preferredProviders = useSelector(state => state.booking.preferredProviders)
    const preferredProviderLoading = useSelector(state => state.booking.preferredProviderLoading)
    const selectedPartnerId = useSelector(state => state.form?.PreferredProviderForm?.values?.preferredPartnerId);
    const promoId = useSelector(state => formValueSelector('PromoCodeForm')(state, 'promoId'))
    const isPromoIdRemove = useSelector(state => formValueSelector('PromoCodeForm')(state, 'isPromoIdRemove'))
    const paymentMethodId = useSelector(state => formValueSelector('PaymentMethod')(state, 'paymentMethodId'))
    const description = useSelector(state => formValueSelector('OrderDetails')(state, 'description'))
    // Parity with mobile: appointment time (W2), duration (W3) and questionnaire answers (W4).
    const scheduledAt = useSelector(state => formValueSelector('OrderDetails')(state, 'scheduledAt'))
    const estimatedHours = useSelector(state => formValueSelector('OrderDetails')(state, 'estimatedHours'))
    const questionnaire = useSelector(state => formValueSelector('OrderDetails')(state, 'questionnaire'))

    const dispatch = useDispatch();
    const { formatMessage } = useIntl();

    const handleClick = () => {
        // Back goes to the booking-flow entry ("How would you like to book?"); the old combined
        // "Choose your provider" picker has been removed (the two flows are chosen at the entry now).
        dispatch(closeHeaderModal('preferredProviderForm'))
        dispatch(openHeaderModal('bookingForm'))
    }

    useEffect(() => {
        const handleProviderRefetch = async () => {
            const bookingData = formData?.bookingData;
            const orderItem = bookingData?.orderItemsList?.[0];

            // Parity with the app's getServiceProvider: order-based, calendar-aware, priced-per-worker.
            const variables = {
                orderId: bookingData?.id,
                dropOffLat: orderItem?.dropLat,
                dropOffLng: orderItem?.dropLng,
                requestCurrency: bookingData?.currency,
                // OrderDetails.scheduledAt is a unix timestamp (seconds); the resolver wants an ISO string.
                scheduledAt: scheduledAt ? new Date(scheduledAt * 1000).toISOString() : null,
                estimatedHours: estimatedHours || null,
            };
            await dispatch(getServiceProvider(variables));
        }
        handleProviderRefetch()
    }, [])

    const handleConfirmBooking = async () => {
        const bookingData = formData?.bookingData;
        const orderItem = bookingData?.orderItemsList?.[0];

        const orderId = bookingData?.id;
        const requestCurrency = bookingData?.currency;
        const reviewDescription = bookingData?.orderDetails?.description?.trim() ? description : null;

        const dropOffLocation = orderItem?.dropLocation;
        const dropOffLat = orderItem?.dropLat;
        const dropOffLng = orderItem?.dropLng;

        const validPromoId = !isPromoIdRemove
            ? promoId ?? bookingData?.promoId
            : null;

        // A worker shared their profile link (/pro) → that pro is preselected for this booking.
        let sharedPro = null;
        try { if (typeof window !== 'undefined') sharedPro = window.localStorage.getItem('bh_preferred_pro'); } catch (e) {}
        const preferredPartnerId = selectedPartnerId || sharedPro || undefined

        dispatch(closeHeaderModal('preferredProviderForm'))
        // LOCKED (booking flow): the 3rd arg `true` = isPreffered. MANDATORY for the preferred flow —
        // it tells NearestProviderForm to wait for the chosen worker and NOT arm the 60s broadcast board
        // timer. Drop it and a confirmed preferred booking sautes to the board after a minute.
        dispatch(openHeaderModal('nearestProviderForm', null, true))

        await dispatch(createBookingAction({ orderId, requestCurrency, reviewDescription, dropOffLocation, dropOffLat, dropOffLng, promoId: validPromoId, paymentType: Number(paymentMethodId), preferredPartnerId, scheduledAt: scheduledAt || null, estimatedHours: estimatedHours || null, questionnaire: questionnaire || null }))
        try { if (typeof window !== 'undefined') window.localStorage.removeItem('bh_preferred_pro'); } catch (e) {}

    }

    return (
        <>
            {preferredProviderLoading && <div className={bt.modalLoader}>
                <Loader type="circle" show={preferredProviderLoading} />
            </div>}
            {
                !preferredProviderLoading && preferredProviders?.length > 0 && (<div>
                    <div className="preferredProviderCardWrapper">
                        {preferredProviders.map((provider, index) => {
                            return (
                                <PrefferedProviderDetails providerData={provider} key={index} />
                            );
                        })}
                    </div>
                    <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                        <Button onClick={() => handleClick()} className={bt.btnSecondary} ><FormattedMessage {...messages.goBackText} /> </Button>
                        <div>
                            <Loader
                                type='button'
                                buttonType='submit'
                                label={formatMessage(messages.confirm)}
                                disabled={!selectedPartnerId}
                                handleClick={() => handleConfirmBooking()}
                                className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                            />
                        </div>
                    </div>

                </div>)
            }
            {
                !preferredProviderLoading && preferredProviders?.length === 0 &&
                <div>
                    <div className={bt.nearestNoServiceImgContainer} >
                        <img src={noServiceProviderIcon} alt="No Service Provider" />
                    </div>
                    <div className={cx(bt.fontWeight700, bt.commonSize20, bt.primaryColor, bt.textAlignCenter)}> <FormattedMessage {...messages.noProviderAvailable} /></div>
                    <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                        <Button onClick={() => handleClick()} className={cx(bt.btnSecondary, bt.cursorPointer)}><FormattedMessage {...messages.goBackText} /> </Button>
                    </div>
                </div>

            }
        </>
    )

}

PreferredProviderForm = reduxForm({
    form: 'PreferredProviderForm',
})(PreferredProviderForm);

export default withStyles(bt)(PreferredProviderForm)
